<template>
	<ppe-form 
		entityName="Operation"
		title="Projet / Opération" 
		title-field=""
 	  sub-title=""
		:schema="schema" 
		:endpoint="endpoint"
		:redirect="'/ppe_eu/operation_home/:id'" 
		v-on:dataLoaded="onDataLoaded"
		>

	</ppe-form>
</template>
<script>
 
//import Utils from 'businessutils'
import Business from 'ppe-business'
import Utils    from '../ppe/utils'
import usermanager from '../../usermanager';

export default {
	data() {
		console.log("C_Operation.vue:this.$route.params.id", this.$route.params.id)
		console.log("C_Operation.vue:this.$route.query.selectedeu", this.$route.query.selectedeu)
		
		return {
		  //companies : {},
			//company: this.$route.query.selectedeu,
			endpoint : "/eu/operation?accountid="+this.$route.params.accountid + (this.$route.params.id?'&id='+this.$route.params.id:''),
			schema : [
			{ card:"Chargement ...",
					body:[	
						{component:'div', children:'en cours'}
						]
		   }
			]
		}
	},
	methods : {
		onDataLoaded(data) {
			console.log("onDataLoaded", data)
			let euList = []
			euList = data.companies.map( function (c) { return {label:c.name, value:c.id} })
			euList.unshift({label:'(Choisissez)', value:''})
			
			this.schema = 
			[
				{ card:"Lieu de l'intervention",
					body:[																													  // dynamically add companies to the list
						{name:"company",    label:"Société / Pole", type: "select",  options: euList },
						{name:"sitename",   label:"Site",    type: "text",     validation: 'required', size:'medium', placeholder:'ex: Siège, Batiment de stockage, ...'},
						{name:"address",    label:"Adresse", type: "textarea", validation: 'required', size:'large'},
						{name:"zip",        label:"Code postal",             type: "number",   validation: 'required', size:'small'},
						{name:"city",       label:"Ville",                                     validation: 'required'},
						// {name:"country",    label:"Pays",                    type:'select',    validation: 'required', size:'small', options:{'':'', fr:'France', be:'Belgique'}},
					],
				}, 
				{ card: "Type d'opération",
					body : [
						{name:"code",          label:"Numéro de projet (lettres, chiffres et tirets)", 	type: "text",     	validation: 'required|checkCodeValidity', placeholder:'ex : T22-10-001 Entrer un numéro unique.', },
						{name:"operationname", label:"Désignation du projet",             				type: "text",     	validation: 'required'},
						{name:"type",   			 label:"Projet / Opération",     										type: "radio",    	validation: 'required', options: Business.getOperationsOptions(!usermanager.isAdmin()) },
						{name:"description",   label:"Description des interventions programmées", type: "textarea",   validation: ''},
						{name:"startDate",   	 label:"Date de début d'intervention",              type: "datepicker", validation: 'required', placeholder:'JJ/MM/AAAA', size:'small', language:"fr", format:"dd/MM/yyyy", typeable:true},
						{name:"duration",   	 label:"Durée programmée (jours / mois)",           type: "text",     	validation: '', size:'small'},
						{name:"workingHours",  label:"Horaires de travail",                				type: "text",     	validation: '', size:'small'},
						{name:"nonWorkingDays",label:"Travail jours non ouvrés",                	type: "checkbox",   validation: '', size:'small', style: "'display:flex'" },
				],
				}, 
				{ card: "Organisation de l'opération",
					body : [
						{component:'div', children:"Nombre d'entreprises programmées", size:'small'},
						{name:"companyCountExpected",  label:"",  type: "number",     validation: '', size:'small'},
						{component:'div', children:' ', size:'large'},
						{component:'div', children:'Maître d’ouvrage', size:'small', style:"display:flex; align-items: center; justify-content: flex-end;" },
						{name:"projectOwner.name",      label:"Nom",             type: "text",    size:'small'},
						{name:"projectOwner.phone",     label:"Téléphone",       type: "text",    size:'small'},
						{name:"projectOwner.email",     label:"Email",           type: "email",   size:'small'},

						{component:'div', children:'Maître d’œuvre', size:'small', style:"display:flex; align-items: center; justify-content: flex-end;"},
						{name:"mainContractor.name",     placeholder:"Nom",      type: "text",    size:'small'},
						{name:"mainContractor.phone",    placeholder:"Téléphone",type: "text",    size:'small'},
						{name:"mainContractor.email",    placeholder:"Email",    type: "email",   size:'small'},

						{component:'div', children:'Responsable du projet', size:'small', style:"display:flex; align-items: center; justify-content: flex-end;"},
						{name:"projectManager.name",     placeholder:"Nom",       type: "text",    size:'small'},
						{name:"projectManager.phone",    placeholder:"Téléphone", type: "text",    size:'small'},
						{name:"projectManager.email",    placeholder:"Email",     type: "email",   size:'small'},

						{component:'div', children:'Préventeur C.SPS', size:'small', style:"display:flex; align-items: center; justify-content: flex-end;"},
						{name:"CSPSPreventer.name",      placeholder:"Nom",       type: "text",    size:'small'},
						{name:"CSPSPreventer.phone",     placeholder:"Téléphone",type: "text",    size:'small'},
						{name:"CSPSPreventer.email",     placeholder:"Email",    type: "email",   size:'small'},
					]
				}, 
				{ card: "Organisation des Secours",
					body : [
						{name:"groupingZone",            label:"Zone de regroupement en cas d’évacuation", 		 type: "textarea",     validation: ''},
						{name:"onSiteSupport", 					 label:"Assistance et guidage sur site", 		 type: "textarea",     validation: ''},
						{name:"accidentProcedure",       label:"Procédure en cas d'accident", 		 type: "textarea",     validation: '', value: "Appeler le 15 ou le 18 \nDécliner votre identité\nPréciser le lieu et la nature de l'accident\nAttendre les instructions de votre interlocuteur"},
						{name:"externalEmergencyAccess", label:"Accès des secours extérieurs", 		 type: "textarea",     validation: ''},
						
						{name:"secutityCenterLocation", label:"Localisation du PC Sécurité", 		 type: "textarea",     validation: ''},
						{name:"secutityCenterPhone",     label:"Téléphone PC Sécurité",    type: "text",    size:'small'},
						{name:"defibrillatorLocation", label:"Localisation défibrillateur :", 		 type: "textarea",     validation: ''},
						{component:'div', children:'', size:'medium', style:""},
						
						{component:'div', children:'Préventeur sécurité', size:'small', style:"display:flex; align-items: center; justify-content: flex-end;" },
						{name:"securityOfficer.name",      label:"Nom",          type: "text",    size:'small'},
						{name:"securityOfficer.phone",     label:"Téléphone",    type: "text",    size:'small'},
						{name:"securityOfficer.email",     label:"Email",        type: "email",   size:'small'},

					] 
				},
				{ card: "Cheminements pour accéder à l’Opération",
					body : [
					{name:"siteAccess", 					 label:"Description", 		 type: "textarea",    size:"large", validation: ''},
					{name:"siteAccess1Title", label:"Titre de cette image 1",  placeholder:"Indiquer le titre à donner à cette image (facultatif)",  type: "text",    size:'large'},
					{name:"siteAccessImage1",      type:'FormImage', width:"100%" },
					{name:"siteAccessImage1",   	 label:"Image 1",    type: "image",  validation: 'mime:image/png,image/jpeg,image/jpg;', size:'medium', placeholder:'Image 1 (jpeg, jpg, png)'},

					{name:"siteAccess2Title", label:"Titre de cette image 2",  placeholder:"Indiquer le titre à donner à cette image (facultatif)",  type: "text",    size:'large'},
					{name:"siteAccessImage2",      type:'FormImage', width:"100%" },
					{name:"siteAccessImage2",   	 label:"Image 2",    type: "image",  validation: 'mime:image/png,image/jpeg,image/jpg;', size:'medium', placeholder:'Image 2 (jpeg, jpg, png)'},
				]},

				{ card: "CARACTERISTIQUES du SITE",
					body : [
					{name:"technicalCharacteristics",	label:"CONNAISSANCE des CARACTERISTIQUES TECHNIQUES du SITE à reporter sur le plan du site", type: "checkbox",   validation: '', size:'medium', options: Business.technicalCharacteristics, style: "display:flex; margin-bottom:0px;"},
					{name:"forbiddenZones", 					label:"zones interdites aux chauffeurs", 		 type: "textarea",    size:"medium", validation: ''},
					{component:'label', children:"* en fonction du lieu de livraison (déterminé par le demandeur)", size:"large"},
					{name:"fixedEquipment",						label:"Equipement fixe", 	 type: "checkbox",   validation: '', size:'medium', options: Business.fixedEquipment,  style: "'display:flex'" },
					{name:"mobileEquipment",					label:"Equipement mobile", type: "checkbox",   validation: '', size:'medium', options: Business.mobileEquipment, style: "'display:flex'" },
					] 
				},

				{
					card:"Images",
					body:[
						{name:"image",      type:'FormImage', width:"100%" },
						{name:"image",   		label:"Image de couverture",    type: "image",  validation: 'mime:image/png,image/jpeg,image/jpg;', size:'medium', placeholder:'Image de couverture (jpeg, jpg, png)'},

						{name:"map",      type:'FormImage', width:"100%" },
						{name:"map",   		label:"Image du plan du site",    type: "image",  validation: 'mime:image/png,image/jpeg,image/jpg;', size:'medium', placeholder:'Image du plan du site (jpeg, jpg, png)'},
					]
				},

				Utils.getGetManagerCard({done:true}),

				Utils.getAdminCard(),

				];

				// Preselect the companyid if specified in the URL
				if(this.$route.query.selectedeu)
					data.entity.company = this.$route.query.selectedeu

		},
 
	},

};
</script>
<style>
.display-inline {
	display:   flex;
	flex-wrap: wrap;
}
</style>
